import React, { Component } from 'react';
import './style.scss';
import { withStickerOverlay } from '../StickerOverlay';
import { Video } from '../Video';
import { Scrubber } from '../Scrubber';

const McqOverlay = ({ quiz, height, width }) => {
  return (
    <div className={'mcq-overlay'} style={{ height: `${height}px`, width: `${width}px` }}>
      {quiz.options.map((option) => {
        return (
          <div className={'checkbox-container'} style={{ position: 'absolute', top: `${option.pointer.y * height}px`, left: `${option.pointer.x * width}px` }}>
            <input type='checkbox' />
          </div>
        );
      })}
    </div>
  );
};
function between(x, min, max) {
  return x >= min && x <= max;
}

function uuid() {
  var dt = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}

const VideoWithStickerOverlay = withStickerOverlay(Video);

class Player extends Component {
  constructor(props) {
    super(props);
    this.state = { size: {}, activeStickers: [], style: { height: '100%', width: '100%' } };
    this.onPause = this.onPause.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.videoElement = React.createRef();
    this.onVideoMount = this.onVideoMount.bind(this);
    this.onFullScreenToggle = this.onFullScreenToggle.bind(this);
    this.onPlayToggle = this.onPlayToggle.bind(this);
    this.onTogglePlayKnob = this.onTogglePlayKnob.bind(this);
  }

  onVideoMount() {
    this.videoElement.current.addEventListener('loadedmetadata', (event) => {
      const { config, onLoadMetaData } = this.props;
      const { stickers } = config;

      window.addEventListener('resize', () => {
        const { isFullScreen } = this.state;
        if (isFullScreen) {
          this.setState({
            size: {
              height: window.innerHeight,
              width: window.innerWidth,
              offsetX: window.innerWidth - this.videoElement.current.offsetWidth,
              offsetY: window.innerHeight - this.videoElement.current.offsetHeight,
            },
          });
        } else {
          this.setState({
            size: {
              height: this.videoElement.current.offsetHeight,
              width: this.videoElement.current.offsetWidth,
            },
          });
        }
      });

      this.setState({
        stickers: stickers.map((sticker) => ({ ...sticker, id: uuid(), visible: false })),
        size: { height: this.videoElement.current.offsetHeight, width: this.videoElement.current.offsetWidth },
      });

      this.sliderRef.setValue(0);

      onLoadMetaData && onLoadMetaData(event);
      const videoObject = this.videoElement.current;
      videoObject.addEventListener('timeupdate', (event) => {
        const currentTime = videoObject.currentTime;
        const { config, onUpdateSticker } = this.props;
        const { stickers } = config;
        this.sliderRef.setValue(currentTime);
        this.setState({
          currentTime,
          activeStickers: stickers.map((sticker) => {
            let updatedSticker = { id: uuid(), ...sticker, visible: false };
            if (between(currentTime - 0.2, sticker.at, sticker.at + sticker.duration)) {
              updatedSticker = { id: uuid(), ...sticker, visible: true };
            }
            onUpdateSticker && onUpdateSticker(updatedSticker);
            return updatedSticker;
          }),
        });

        const { onTimeUpdate } = this.props;
        onTimeUpdate &&
          onTimeUpdate({
            currentTime,
          });
      });
    });
  }

  onPlayToggle() {
    const { isPlaying } = this.state;
    if (isPlaying) {
      this.videoElement.current.pause();
    } else {
      this.videoElement.current.play();
    }
    this.setState({ isPlaying: !isPlaying });
  }

  onPlay() {
    this.videoElement.current.play();
  }

  onPause() {
    this.videoElement.current.pause();
  }

  onFullScreenToggle() {
    const { size, oldSize, isFullScreen } = this.state;
    if (isFullScreen) {
      this.setState({
        isFullScreen: false,
        size: oldSize,
        style: {},
      });
    } else {
      this.setState({
        isFullScreen: true,
        oldSize: size,
        size: {
          height: window.innerHeight,
          width: window.innerWidth,
          offsetX: window.innerWidth - this.videoElement.current.offsetWidth,
          offsetY: window.innerHeight - this.videoElement.current.offsetHeight,
        },
        style: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        },
      });
    }
  }

  onTogglePlayKnob() {
    this.sliderRef && this.sliderRef.toggleKnob();
  }

  render() {
    const { src, onUpdateSticker, onDeleteSticker, config, editMode = false } = this.props;
    const { size, activeStickers, quiz, style = {}, isPlaying, isFullScreen, currentTime } = this.state;
    const { stickers } = config;
    return (
      <div style={style} onClick={this.onTogglePlayKnob}>
        <VideoWithStickerOverlay
          editMode={editMode}
          stickers={editMode ? stickers : activeStickers}
          size={size}
          src={src}
          videoRef={this.videoElement}
          onVideoMount={this.onVideoMount}
          onUpdateSticker={onUpdateSticker}
          onDeleteSticker={onDeleteSticker}
        />

        <div className={'video-controls-container '}>
          <div className={'video-controls'}>
            {this.videoElement.current && (
              <Scrubber
                ref={(ref) => {
                  this.sliderRef = ref;
                }}
                max={this.videoElement.current.duration}
                onChange={({ value }) => {
                  this.videoElement.current.currentTime = value;
                }}
              />
            )}

            <div className={'options'}>
              <button className={'play-button'} onClick={this.onPlayToggle}>
                {isPlaying ? <img src='/icons/pause.svg' /> : <img src='/icons/play.svg' />}
              </button>
              <div className={'time'}>{currentTime ? `${Math.round(currentTime)}s` : '--'}</div>
              <button className={'fullscreen-button'} onClick={this.onFullScreenToggle}>
                {isFullScreen ? <img src='/icons/fullscreen-exit.svg' /> : <img src='/icons/fullscreen.svg' />}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Player;
